import React from 'react';
import cx from 'classnames';
import { connect } from 'react-redux';
import { Field, Form, reduxForm } from 'redux-form';

import FormInputText from '../global/form-input-text';
import FormInputDateDropdown from '../global/form-input-date-dropdown';
import TranslatedCopy from '../../intl/translated-copy';
import { birthdayDate, genericEmail } from '../../validation/user-profile-email-validator';
import userProfileSAccountRecoveryValidation from '../../validation/user-profile-email-validations';
import AccountNumberRecoverySuccess from './account-number-recovery-success';
import AccountNumberRecoveryError from './account-number-recovery-error';
import LoadingScreen from '../global/loading-screen';
import { USER_PROFILE_RECOVER_ACCOUNT_FORM_ID } from '../../constants/form-ids';
import { recoverAccountReset, sendRecoverAccount } from '../../../redux/actions';
import { recoverAccountMicroTypeErrors, recoverAccountTypeErrors } from '../../constants/user-profile-recover-account';
import UserProfileErrorDisconnection from './user-profile-error-disconnection';

function AccountNumberRecovery(props) {
  const {
    closeModalLogin,
    dispatch,
    handleSubmit,
    helperTraslatedCopy,
    onClickBack,
    profileRecoverAccount: {
      recoverAccountError = null,
      recoverAccountLoading = false,
      recoverAccountSent = null,
    },
    reset,
    valid,
  } = props;

  const {
    code = null,
  } = recoverAccountError || {};

  const showFormView = !recoverAccountError && !recoverAccountSent;
  const showSuccessView = recoverAccountSent && !recoverAccountError;
  const showErrorView = !recoverAccountSent && recoverAccountError;

  const accountError = Boolean(recoverAccountTypeErrors.includes(code));
  const microError = Boolean(recoverAccountMicroTypeErrors.includes(code) || code >= 500);

  const showLoading = Boolean(recoverAccountLoading);

  const AccountRecoverFormClasses = cx('AccountNumberRecovery', {
    'AccountNumberRecovery--Loading': showLoading,
  });

  const handleSubmitForm = ({ emailNumberRecovery, birthdayDateRecovery }) => {
    const data = {
      birthDate: birthdayDateRecovery,
      email: emailNumberRecovery,
    };

    dispatch(sendRecoverAccount(data));
  };

  const handleBackButtonClick = () => {
    reset();
    dispatch(recoverAccountReset());
  };

  const handleCloseModal = () => {
    closeModalLogin(showSuccessView);
  };

  return (
    <>
      { showLoading &&
        <LoadingScreen
          isDataLoading={ true }
          seatmap={ true }
          type='airplaneWindow'
        />
      }
      { !microError &&
        <div className={ AccountRecoverFormClasses }>
          <div className='AccountNumberRecovery-Back'>
            <button
              className='AccountNumberRecovery-Back-button'
              onClick={ onClickBack }>
              <div className='AccountNumberRecovery-Back-icon'>
                <span className='Icon Icon--calendarArrowLeft' />
              </div>
              <TranslatedCopy
                className='AccountNumberRecovery-Back-text'
                copyID='PRO_HOME_FORGOT_MY_USER_LOGIN'
              />
            </button>
          </div>
          { showFormView &&
            <>
              <div className='AccountNumberRecovery-Info'>
                <TranslatedCopy
                  className='AccountNumberRecovery-Info-title'
                  copyID='PRO_HOME_FORGOT_MY_USER_TITLE'
                  tagName='p'
                />
                <TranslatedCopy
                  className='AccountNumberRecovery-Info-subtitle'
                  copyID='PRO_HOME_FORGOT_MY_USER_DESCRIPTION'
                  tagName='p'
                />
              </div>
              <Form className='AccountNumberRecovery-Form' onSubmit={ handleSubmit(handleSubmitForm) }>
                <Field
                  className='UserProfileLoginForm-home'
                  component={ FormInputText }
                  isRequired={ true }
                  key='inputEmailCPNumberRecovery'
                  labelClassModifier='account-recovery'
                  labelCopyID='PRO_HOME_FORGOT_MY_USER_EMAIL'
                  maxLength={ 60 }
                  minLength={ 5 }
                  name='emailNumberRecovery'
                  showIconInput={ true }
                  type='text'
                  validate={ genericEmail }
                />
                <Field
                  autocompleteGroupName='bday'
                  checkIcon={ false }
                  className='FormInput-wrapper FormInput-wrapper UserProfileLogin-formInput UserProfileLoginForm-home FormImput-birthdayDate'
                  component={ FormInputDateDropdown }
                  helperTraslatedCopy={ helperTraslatedCopy }
                  isRequired={ true }
                  key='inputBirthdayDateRecovery'
                  labelClassModifier='BirthDay'
                  labelCopyID='PRO_HOME_FORGOT_MY_USER_BIRTHDATE'
                  monthsInNumbers={ true }
                  name='birthdayDateRecovery'
                  setStateOnUpdate={ true }
                  validate={ birthdayDate }
                  withDivider={ true }
                />
                <div className='AccountRecoveryFooter'>
                  <button
                    type='submit'
                    className='AccountRecoveryButton'
                    disabled={ !valid } >
                    <TranslatedCopy copyID='PRO_HOME_FORGOT_MY_USER_BUTTON' />
                  </button>
                  <TranslatedCopy
                    className='AccountRecovery-captcha'
                    copyID='USER_PROFILE_LEGAL_CAPTCHA'
                    tagName='p'
                  />
                </div>
              </Form>
            </>
          }
          { showSuccessView &&
            <AccountNumberRecoverySuccess closeModalLogin={ handleCloseModal } /> }
          { (showErrorView && accountError) &&
            <AccountNumberRecoveryError closeModalLogin={ handleCloseModal } /> }
        </div>
      }
      { (showErrorView && microError) &&
        <UserProfileErrorDisconnection
          onBackButtonClick={ handleBackButtonClick }
          onCloseModal={ handleCloseModal }
        />
      }
    </>
  );
}

const mapStateToProps = function(state) {
  return {
    dispatch: state.dispatch,
    helperTraslatedCopy: state.LanguageBundle.helperTraslatedCopy,
    profileRecoverAccount: state.Manage.profileRecoverAccount,
    storefront: state.Manage.storefront,
  };
};

AccountNumberRecovery = reduxForm({
  destroyOnUnmount: true,
  form: USER_PROFILE_RECOVER_ACCOUNT_FORM_ID,
  validate: userProfileSAccountRecoveryValidation,
})(AccountNumberRecovery);

AccountNumberRecovery = connect(mapStateToProps)(AccountNumberRecovery);

export default AccountNumberRecovery;